import { alpha, Stack, useTheme } from "@mui/material";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
	tone: "info" | "warning" | "muted";
}>;

export const AmountNotice: React.FC<Props> = ({ tone, children }) => {
	const theme = useTheme();

	const background =
		tone === "warning"
			? alpha(theme.palette.warning.main, 0.08)
			: tone === "muted"
				? theme.palette.surface.muted
				: alpha(theme.palette.blue[50], 0.4);

	return (
		<Stack
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			gap={theme.spacingTokens.xs}
			borderTop={1}
			borderColor="surface.border"
			bgcolor={background}
		>
			{children}
		</Stack>
	);
};
